"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotUniqueId = exports.getNewNumber = exports.CONTROL_COLLECTION_NAME = exports.RISK_COLLECTION_NAME = exports.PROCESS_COLLECTION_NAME = exports.CYCLE_COLLECTION_NAME = void 0;
var lodash_1 = __importDefault(require("lodash"));
var firebase = __importStar(require("../firebase/fbase"));
exports.CYCLE_COLLECTION_NAME = 'CYCLE';
exports.PROCESS_COLLECTION_NAME = 'PROCESS';
exports.RISK_COLLECTION_NAME = 'RISK';
exports.CONTROL_COLLECTION_NAME = 'CONTROL';
function getNewNumber(prefix, values) {
    var targets = lodash_1.default.filter(values, function (value) { return lodash_1.default.startsWith(value.id, prefix); });
    var max = (lodash_1.default.max(lodash_1.default.map(targets, function (target) {
        var lastId = lodash_1.default.last(lodash_1.default.split(target.id, '-')) || '0';
        var lastNumber = lodash_1.default.parseInt(lodash_1.default.includes(['R', 'C'], lastId.charAt(0)) ? lastId.slice(1) : lastId);
        return !lodash_1.default.isNaN(lastNumber) ? lastNumber : 0;
    })) || 0) + 1;
    return max < 10 ? '0' + String(max) : String(max);
}
exports.getNewNumber = getNewNumber;
function isNotUniqueId(id) {
    return __awaiter(this, void 0, void 0, function () {
        var collections, _i, _a, _b, key, collection, doc;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    collections = {
                        cycle: exports.CYCLE_COLLECTION_NAME,
                        process: exports.PROCESS_COLLECTION_NAME,
                        risk: exports.RISK_COLLECTION_NAME,
                        control: exports.CONTROL_COLLECTION_NAME
                    };
                    _i = 0, _a = Object.entries(collections);
                    _c.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 4];
                    _b = _a[_i], key = _b[0], collection = _b[1];
                    return [4 /*yield*/, firebase.dbService.collection(collection).doc(id).get()];
                case 2:
                    doc = _c.sent();
                    if (doc.exists) {
                        return [2 /*return*/, key];
                    }
                    _c.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, undefined];
            }
        });
    });
}
exports.isNotUniqueId = isNotUniqueId;
//# sourceMappingURL=RCMUtils.js.map